// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__30f7i","title":"AfterBackImages_title__BkFfI","images":"AfterBackImages_images__2MMux"};